/**
 * 온보딩 격리 중 가로챈 딥링크 보관소 (CP1 D4 — 격리 우선 + 완료 후 재생)
 *
 * 홈 진입 딥링크(?view=…)는 격리 중 소비하지 않고 여기 보관했다가,
 * 온보딩 완료 직후 consumeOnboardingDeepLink 로 꺼내 그 창을 열어준다.
 *
 * userId 스코프 필수 — sessionStorage 는 같은 탭의 로그아웃·재로그인을 넘어 살아남으므로,
 * 스코프 없이는 앞 사용자의 착지 좌표(알림 딥링크)가 다음 사용자에게 재생된다 (CP2 리뷰).
 */
import type { DeepLink } from '@aegislab/shared';

export const ONBOARDING_DEEP_LINK_STASH_KEY = 'onboarding-deeplink-replay';

export function stashOnboardingDeepLink(userId: string, deepLink: DeepLink): void {
  try {
    sessionStorage.setItem(ONBOARDING_DEEP_LINK_STASH_KEY, JSON.stringify({ userId, deepLink }));
  } catch {
    // storage 불가 환경(프라이빗 모드 등) — 재생만 포기, 격리는 유지
  }
}

/** 보관분을 소비한다 — userId 불일치(다른 사용자의 보관분)면 폐기하고 null. 어느 쪽이든 보관소는 비운다. */
export function consumeOnboardingDeepLink(userId: string): DeepLink | null {
  try {
    const raw = sessionStorage.getItem(ONBOARDING_DEEP_LINK_STASH_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(ONBOARDING_DEEP_LINK_STASH_KEY);
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    const { userId: ownerId, deepLink } = parsed as {
      userId?: unknown;
      deepLink?: { view?: unknown; context?: DeepLink['context'] };
    };
    if (ownerId !== userId) return null;
    if (!deepLink || typeof deepLink.view !== 'string' || deepLink.view.length === 0) return null;
    return {
      view: deepLink.view,
      context: deepLink.context && typeof deepLink.context === 'object' ? deepLink.context : {},
    };
  } catch {
    try {
      sessionStorage.removeItem(ONBOARDING_DEEP_LINK_STASH_KEY);
    } catch {
      // storage 접근 자체가 불가 — 비울 것도 없다
    }
    return null;
  }
}
